import { render, staticRenderFns } from "./BaseDropItem.vue?vue&type=template&id=1e38a6a0&scoped=true&"
import script from "./BaseDropItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./BaseDropItem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e38a6a0",
  null
  
)

export default component.exports